// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"daead57b","453":"6f021184","948":"5ec6abf4"}[chunkId] + ".chunk.js";
};